import './404.scss';

console.log('404.js');